// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {atom, onMount, computed} from 'nanostores';
import etask from '/util/etask.js';
import store from '@pub/store.js';
import {STORAGE_KEYS} from '@pub/utils/constants.js';
import * as local_storage from '@pub/utils/local_storage.js';
import * as api from '../api.js';

export const $user = atom({});
export const $loading = atom(true);
export const $loaded = atom(false);
export const $is_root = computed($user, user=>{
    if (!user)
        return false;
    return !!(user.original_user?.is_root || user.is_root);
});

const fetch = ()=>void etask(function*(){
    $loading.set(true);
    $loaded.set(false);
    try {
        const data = yield api.fetch_user();
        $user.set(data);
        $loaded.set(true);
    } finally {
        $loading.set(false);
    }
});

onMount($user, fetch);

export const refresh = ()=>fetch();

export const mimic = email=>{
    local_storage.write(STORAGE_KEYS.USER, email, {session: true});
    store.invalidate();
    refresh();
};

export const stop_mimic = ()=>{
    local_storage.cleanup(STORAGE_KEYS.USER);
    store.invalidate();
    refresh();
};

export const toggle_bvpn_ref = value=>etask(function*(){
    $loading.set(true);
    try {
        yield api.toggle_bvpn_ref(value);
        store.invalidate();
        refresh();
    } finally {
        $loading.set(false);
    }
});

export const set_multiplier = value=>etask(function*(){
    $loading.set(true);
    try {
        yield api.set_user_multiplier(value);
        store.invalidate();
        refresh();
    } finally {
        $loading.set(false);
    }
});
